import Chart from "pro-features/components/Chart/src/Chart";
import { chartTypes } from "app/UtilitiesAndConstants/Constants/ChartTypes";

import { pieGraphKeys } from "../automationKeys";

import { defaultEmptyPieData, pieConfig } from "./config";
import { StyledChartWrapper } from "./style";
import type { PieGraphSchema } from "./type";

export const PieGraph = ({ chartData, isLoading }: PieGraphSchema) => (
    <StyledChartWrapper
        isLoading={isLoading}
        data-automation={pieGraphKeys.wrapper}
    >
        <Chart
            type={chartTypes.PIE}
            data={
                chartData && !isLoading
                    ? [
                          {
                              data: chartData,
                          },
                      ]
                    : defaultEmptyPieData
            }
            config={pieConfig}
        />
    </StyledChartWrapper>
);
